import React, { Component } from 'react';
import $ from 'jquery';
import { FORMAT_NUMBER, CURRENCY } from '../libs/utils/Const';
import { ApplyDownPayment } from './NewOrder'

class DownPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            balanceDP: 0,
        };
    }

    componentDidMount() {
        this.closeAction();
    }

    closeModal = async () => {
        $('#downPayments').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#downPayments').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    selectItemsToArray = async () => {
        const { data, newOrderModel, refreshModel, checkbox, refreshTotal } = this.props;

        let downPayments = [];
        let downPaymentAmount = 0;

        for (let [id, value] of checkbox.data.entries()) {
            if (value) {
                let modelDownPayment = new ApplyDownPayment();
                modelDownPayment.DocEntry = data[id].DocEntry;
                modelDownPayment.AmountToDraw = data[id].BaseAmntEdit;
                downPayments.push(modelDownPayment);
                downPaymentAmount = downPaymentAmount + Number(data[id].BaseAmntEdit);
            }
        }
        newOrderModel.DownPaymentsToDraw = downPayments;
        newOrderModel.DownPaymentAmount = downPaymentAmount;
        await refreshModel(newOrderModel);
        await refreshTotal(newOrderModel);
    };

    CheckBoxSelectOneAux = async (index) => {
        await this.props.checkbox.selectOne(index);
        this.selectItemsToArray()
    }

    ChangeApplyDpm = async (index, value) => {
        await this.props.ChangeDowPaymentData(index, value);
        this.selectItemsToArray();
    }



    render() {
        const { data, newOrderModel, checkbox } = this.props;

        return (
            <div>
                <div className="modal fade bd-example-modal-lg" role="dialog" id="downPayments" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title">Facturas de anticipo: {newOrderModel?.CardName ?? ''}</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-inline" style={{ textAlign: "right", marginBottom: '15px' }}>
                                    <div className="form-group mb-2">
                                        <label><strong>Acumulado:&nbsp;&nbsp;</strong></label>
                                        <input
                                            className="form-control btn-outline-secondary custom-input"
                                            type="text"
                                            value={CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.DownPaymentAmount ?? 0.0)}
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <div className="table-responsive" style={{ maxHeight: '400px', overflow: 'auto' }}>
                                    <table className="table table-bordered table-hover">
                                        <thead style={{ backgroundColor: '#f1c40f', textAlign: 'center' }}>
                                            <tr>
                                                <th>#</th>
                                                <th>Selección</th>
                                                <th>No. Doc</th>
                                                <th>Comentarios</th>
                                                <th>Importe a arrastrar</th>
                                                <th>Importe total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((invoice, index) => (
                                                <tr key={index} style={{ textAlign: 'center' }}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => this.CheckBoxSelectOneAux(index)} />
                                                    </td>
                                                    <td>{invoice?.DocNum ?? ''}</td>
                                                    <td>{invoice?.Comments ?? ''}</td>
                                                    <td>
                                                        <input
                                                            className="form-control custom-input"
                                                            type="number"
                                                            value={invoice?.BaseAmntEdit ?? ''}
                                                            onChange={(event) => this.ChangeApplyDpm(index, event.target.value)}
                                                        />
                                                    </td>
                                                    <td>{invoice?.BaseAmnt ?? ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DownPayments;
